import React from 'react'

import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'

export default function WaitingRoomSettings({
  waitingRoomEnabled,
  setWaitingRoomEnabled,
  waitingRoomMaxConcurrent,
  setWaitingRoomMaxConcurrent,
  waitingRoomAdmissionTtlMinutes,
  setWaitingRoomAdmissionTtlMinutes,
  isDisabled,
}) {
  return (
    <>
      <div className="card-body-heading">
        <Card.Title as="h5">Virtual waiting room</Card.Title>
        <Card.Text className="subtitle mb-3">
          Queue fans before they can view inventory or add tickets to cart for
          high-demand onsales.
        </Card.Text>
      </div>

      <Form.Check
        type="switch"
        id="waiting-room-enabled"
        label="Enable waiting room for this event"
        disabled={isDisabled}
        checked={Boolean(waitingRoomEnabled)}
        onChange={(e) => setWaitingRoomEnabled(e.target.checked)}
        className="mb-3"
      />

      {waitingRoomEnabled && (
        <>
          <Form.Group
            className="form-group"
            controlId="waitingRoomMaxConcurrent"
          >
            <Form.Label>Max concurrent shoppers</Form.Label>
            <Form.Control
              type="number"
              min={1}
              name="waitingRoomMaxConcurrent"
              disabled={isDisabled}
              value={waitingRoomMaxConcurrent}
              onChange={(e) => setWaitingRoomMaxConcurrent(e.target.value)}
              className="w-25"
            />
            <Form.Text className="text-muted">
              How many admitted fans can browse and checkout at once. Default
              75.
            </Form.Text>
          </Form.Group>

          <Form.Group
            className="form-group"
            controlId="waitingRoomAdmissionTtlMinutes"
          >
            <Form.Label>Admission session length (minutes)</Form.Label>
            <Form.Control
              type="number"
              min={1}
              name="waitingRoomAdmissionTtlMinutes"
              disabled={isDisabled}
              value={waitingRoomAdmissionTtlMinutes}
              onChange={(e) =>
                setWaitingRoomAdmissionTtlMinutes(e.target.value)
              }
              className="w-25"
            />
            <Form.Text className="text-muted">
              How long an admitted fan keeps their shopping slot without
              heartbeat. Default 15.
            </Form.Text>
          </Form.Group>
        </>
      )}
    </>
  )
}
